export const constants = {
	roles: {
		nurse: 'nurse',
		shiftManager: 'shift-manager',
		bankOfficerManager: 'bank-officer-manager',
		operationalManager: 'operational-manager',
		admin: 'admin',
		rateManager: 'rate-manager',
	},
	approvalStatuses: {
		declined: 'declined',
		banned: 'banned',
		pending: 'pending',
		approved: 'approved',
	},
	newRoles: {
		nurse: 'NURSE',
		shiftManager: 'SHIFT-MANAGER',
		bankOfficerManager: 'BANK-OFFICER-MANAGER',
		operationalManager: 'OPERATIONAL-MANAGER',
		superAdmin: 'SUPER-ADMIN',
		trustAdmin: 'TRUST-ADMIN',
		rateManager: 'RATE-MANAGER',
	},
};
